// Copyright (c) 2020 Deere & Company

import './index.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import BasisForSettlement from './basis-for-settlement';
import ClaimForApproval from '@deere/cps-it.warranty-model-factory/lib/claim-for-approval';
import Comments from './comments';
import Contributions from './contributions';
import {FormattedMessage} from 'react-intl';
import FullClaimDetails from './full-claim-details';
import InternalNotesPanel from '../../../shared/components/notes-panel';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import PricingSummary from './pricing-summary';
import SecureRejectReturnApproveButtons from './secure-reject-return-approve-buttons';
import SpaModal from './modal';
import SpaTypeDropdown from './spa-type';
import TcsmApproveDenyModal from '../../wip/state/tcsm-approve-deny-modal';
import ValuesToApprove from './values-to-approve';
import VsrMessages from '../../../claim/shared/components/vsr-messages';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';

function handleCommentsToDealerChange(comments) {

    this.actions.updateCommentsToDealer(comments);

}

function handleInternalDeereCommentsChange(comments) {

    this.actions.updateInternalDeereComments(comments);

}

function handleConfirmation() {

    this.actions.putSpaClaim(this.claim);
    this.actions.closeModal();

}

function handleReturn() {

    this.actions.openModal('RETURN');
    this.actions.updateStatus('RETURNED');

}

function handleReject() {

    this.actions.openModal('REJECT');
    this.actions.updateStatus('REJECTED');

}

function handleApprove() {

    this.actions.openModal('APPROVE');
    this.actions.updateStatus('APPROVED');

}

function handleSelectedContributionChange(radioListItem) {

    this.actions.updateSelectedContribution(radioListItem.key);

}

function handleSpaTypeChange(selectedType) {

    this.actions.updateSpaType(selectedType, this.spaTypes);

}

class SpaDetails extends Component {

    componentWillMount() {

        this.props.actions.readSpaClaim(this.props.routeParams.claimNumber);

    }

    componentWillUnmount() {

        this.props.actions.resetSpaClaim();

    }

    render() {

        return (
            <section className='spa-details'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <h2>
                    <FormattedMessage id='APPROVAL_DETAILS'/>
                </h2>
                <section className='vsr-messages'>
                    <VsrMessages
                        className='vsr-error-message'
                        vsrMessages={this.props.claim.vsrErrorMessages()}
                    />
                    <VsrMessages
                        className='vsr-warning-message'
                        vsrMessages={this.props.claim.vsrWarningMessages()}
                    />
                    <VsrMessages
                        className='vsr-info-message'
                        vsrMessages={this.props.claim.vsrInfoMessages()}
                    />
                </section>
                <section className='full-details'>
                    {this.props.claim.claimNumber &&
                        <FullClaimDetails
                            claimNumber={this.props.claim.claimNumber}
                        />
                    }
                </section>
                {this.props.claim.notes.length > 0 &&
                <InternalNotesPanel
                    isExpanded={true}
                    notes={this.props.claim.notes}
                />
                }
                <section className='spa-types-dropdown'>
                    <SpaTypeDropdown
                        isSpaTypeChangeAllowed={this.props.claim.isSpaTypeChangeAllowed}
                        onSpaTypeChange={this.props::handleSpaTypeChange}
                        selectedType={this.props.claim.specialAllowanceType}
                        spaTypes={this.props.spaTypes}
                    />
                </section>
                <section className='basis'>
                    <BasisForSettlement
                        basisForSettlement={this.props.claim.basisForSettlement}
                    />
                </section>
                <Contributions
                    contributions={this.props.claim.contributions.current}
                    currency={this.props.claim.claimCurrency.key}
                />
                <PricingSummary
                    list={this.props.claim.pricingSummary.list}
                    net={this.props.claim.pricingSummary.net}
                />
                <ValuesToApprove
                    current={this.props.claim.contributions.current}
                    custom={this.props.claim.contributions.custom}
                    onCustomContributionChange={this.props.actions.updateCustomContribution}
                    onSelectedContributionChange={this.props::handleSelectedContributionChange}
                    selectedContribution={this.props.claim.contributions.selectedContribution}
                />
                <Comments
                    commentsToDealer={this.props.claim.commentsToDealer}
                    internalDeereComments={this.props.claim.internalDeereComments}
                    onCommentsToDealerChange={this.props::handleCommentsToDealerChange}
                    onInternalDeereCommentsChange={this.props::handleInternalDeereCommentsChange}
                />
                <SecureRejectReturnApproveButtons
                    onApprove={this.props::handleApprove}
                    onReject={this.props::handleReject}
                    onReturn={this.props::handleReturn}
                    securityFeature='TABM_SPL_ALLOWANCE_PROCESS'
                    securityModule='TABM'
                />
                <SpaModal
                    claimForApproval={this.props.claim}
                    onClose={this.props.actions.closeModal}
                    onConfirmation={this.props::handleConfirmation}
                    spaCommentsModal={this.props.modal}
                />
            </section>
        );

    }

}

SpaDetails.displayName = 'SpaDetails';
SpaDetails.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    claim: PropTypes.instanceOf(ClaimForApproval).isRequired,
    modal: PropTypes.instanceOf(TcsmApproveDenyModal).isRequired,
    routeParams: PropTypes.object.isRequired,
    spaTypes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair))
};

export default SpaDetails;



// WEBPACK FOOTER //
// ./src/tabm/spa-details/components/index.js